import { Card } from 'antd';
import React, { useContext } from 'react';
import { AppContext } from '../../../AppContext';
import { MODULES } from '../../../common/constants';
import Portal from '../../../components/Portal';
import ImportExportQueueTable from '../components/ImportExportQueueTable';

const ImportExportQueueList = () => {
  const {
    state: { pageSize }
  } = useContext(AppContext);
  return (
    <Card className="full-height-card card-body-padding">
      <Portal portalId="header-left-content">
        <span className="portal-header">{MODULES?.IMPORT_EXPORT_QUEUE}</span>
      </Portal>
      {pageSize && <ImportExportQueueTable />}
    </Card>
  );
};

export default ImportExportQueueList;
